import { onError } from '@apollo/client/link/error';
import { fromPromise } from '@apollo/client/core';
import gqlAuth from '@/api/auth/schemas.graphql';
import client from '@/api/apollo-client';
import useErrors from '@/api/errors';

let isRefreshing = false;
let pendingRequests = [];

const { error } = useErrors();

const AUTH_ERRORS = ['TokenExpiredError', 'JsonWebTokenError'];

const setIsRefreshing = value => {
  isRefreshing = value;
};

const addPendingRequest = pendingRequest => {
  pendingRequests.push(pendingRequest);
};

const resolvePendingRequests = () => {
  pendingRequests.map(callback => callback());
  pendingRequests = [];
};

const getNewToken = async operation => {
  localStorage.removeItem('authToken');
  operation.setContext(() => ({
    headers: {}
  }));

  return client
    .mutate({
      mutation: gqlAuth.getAccessToken,
      variables: {
        input: {
          userRefreshToken: localStorage.getItem('refreshToken'),
          accessTokenExpiration: 24 * 60,
          profileTags: ['application', 'admin', 'user profile']
        }
      }
    })
    .then(response => {
      const authToken = response.data.authAccessToken.jwtToken;

      if (authToken) {
        localStorage.setItem('authToken', authToken);
        return authToken;
      }
    })
    .catch(() => {
      return Promise.reject(new Error('error getting token'));
    });
};

export const errorHandle = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (operation.operationName === 'getTranslations') return;
      if (AUTH_ERRORS.includes(err?.name)) {
        if (!isRefreshing) {
          setIsRefreshing(true);
          return fromPromise(
            getNewToken(operation).catch(() => {
              resolvePendingRequests();
              setIsRefreshing(false);

              localStorage.removeItem('authToken');
              localStorage.removeItem('refreshToken');
              window.location = '/login';
              localStorage.setItem('lastUrlPathname', window.location.pathname);
              return forward(operation);
            })
          ).flatMap(() => {
            resolvePendingRequests();
            setIsRefreshing(false);

            return forward(operation);
          });
        } else {
          return fromPromise(
            new Promise(resolve => {
              addPendingRequest(() => resolve());
            })
          ).flatMap(() => {
            return forward(operation);
          });
        }
      } else {
        error.value = err.message;
      }
    }
  }
});
